import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import logo from "../assets/logo.svg";
import { FaSun, FaMoon, FaUserAlt, FaUserAltSlash } from "react-icons/fa";

import { useTheme } from "../Providers/ThemeContext";
import {
  getValidationSchema,
  validationSchema,
} from "../services/validationSchema";

import { Step1 } from "../Step/PersonalInfo";
import { Step2 } from "../Step/AssociationInfo";
import { Step3 } from "../Step/MembershipFee";
import { Step4 } from "../Step/Confirmation";
import StepIndicator from "../components/StepIndicator";
import CookieBanner from "../components/CookiesBanners";
import { useParams } from "react-router";
import { submitForm } from "../services/services";
import Confirmed from "../Step/Confirmed";
// bWVtYnJlY29udmllcg==  -> TOKEN CONVIER
const FormManager = () => {
  const { token } = useParams();
  const [isInvited, setIsInvited] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [confirmed, setConfirmed] = useState(false);
  const totalSteps = 4;
  const { theme, toggleTheme, colors } = useTheme();
  const year = new Date().getFullYear();

  const steps = Array.from({ length: 4 }, (_, i) => i + 1);
  const filteredSteps = isInvited ? steps.filter((step) => step !== 3) : steps;

  const nextStep = () => {
    const nextIndex = filteredSteps.indexOf(currentStep) + 1;
    if (nextIndex < totalSteps) {
      setCurrentStep(filteredSteps[nextIndex]);
    }
  };

  const prevStep = () => {
    const prevIndex = filteredSteps.indexOf(currentStep) - 1;
    if (prevIndex >= 0) {
      setCurrentStep(filteredSteps[prevIndex]);
    }
  };

  const goToStep = (step) => {
    if (filteredSteps.includes(step)) {
      setCurrentStep(step);
    }
  };

  const handleSubmit = async (values, isInvited) => {
    try {
      const response = await submitForm(values, isInvited);

      setCurrentStep(5);
      if (response.status === 201) {
        setConfirmed(true);
      }
    } catch (error) {
      console.error("Failed to submit form:", error);
    }
  };

  useEffect(() => {
    if (token && token === "bWVtYnJlY29udmllcg==") {
      setIsInvited(true);
    }
  }, [token]);

  return (
    <div
      className="max-w-[60%] max-lg:max-w-[80%] mx-auto p-10 rounded-lg container m-5"
      style={{ backgroundColor: colors.background, color: colors.text }}
    >
      <button
        onClick={toggleTheme}
        className="absolute top-5 right-5 p-2 rounded-full"
        style={{ backgroundColor: colors.background, color: colors.text }}
      >
        {theme === "dark" ? <FaSun /> : <FaMoon />}
      </button>

      {/*<a*/}
      {/*  href={"/login"}*/}
      {/*  className="absolute top-15 right-5 p-2 rounded-full"*/}
      {/*  style={{ backgroundColor: colors.background, color: colors.text }}*/}
      {/*>*/}
      {/*  {<FaUserAlt />}*/}
      {/*</a>*/}
      <div className="flex  flex-col justify-between items-center mb-8 ">
        <h1
          className="text-3xl font-bold mb-3 uppercase"
          style={{ color: colors.primary }}
        >
          {!isInvited
            ? " Formulaire d'adhésion ImagiGeeks"
            : "Formulaire d'inscription convié ImagiGeeks"}
        </h1>

        <div className="flex items-center justify-between w-full">
          <img src={logo} alt="logo IGS" className="w-20 h-20" />
          <h2 className="text-3xl font-bold" style={{ color: colors.primary }}>
            Saison {year} - {year + 1}
          </h2>
        </div>
      </div>

      <StepIndicator
        currentStep={currentStep}
        totalSteps={totalSteps}
        onUpdateClick={goToStep}
        isInvited={isInvited}
      />

      <Formik
        initialValues={{
          nom: "",
          prenom: "",
          pseudo: "",
          dateNaissance: "",
          adressePostale: "",
          zipCode: "",
          city: "",
          email: "",
          telephone: "",
          allergies: "",
          notes: "",
          pmr: false,
          idDiscord: "",
          domainePratique: [],
          motivation: "",
          cosplay: "",
          cultureGeek: "",
          cultureImaginaire: "",
          statut: "",
          modePaiement: "",
          reglementInterieurLu: false,
          dateSignature: "",
          vehicule: false,
        }}
        validationSchema={getValidationSchema(isInvited)}
        onSubmit={async (values, { setSubmitting }) => {
          await handleSubmit(values, isInvited);
          setSubmitting(false);
        }}
      >
        {({ errors, touched, isSubmitting, values }) => (
          <Form className={`space-y-8 transition-transform duration-300`}>
            {currentStep === 1 && <Step1 colors={colors} />}
            {currentStep === 2 && <Step2 colors={colors} />}
            {currentStep === 3 && !isInvited && <Step3 colors={colors} />}
            {currentStep === 4 && (
              <Step4 colors={colors} values={values} isInvited={isInvited} />
            )}
            {confirmed && <Confirmed colors={colors} values={values} />}

            {!confirmed && (
              <div
                className="flex justify-between mt-8"
                style={{ color: colors.secondary }}
              >
                <p>* Ces champs sont requis.</p>
              </div>
            )}

            {!confirmed && (
              <div className="flex justify-between mt-8">
                {currentStep > 1 && (
                  <button
                    type="button"
                    onClick={prevStep}
                    className="px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-opacity-50 transition duration-150 ease-in-out"
                    style={{
                      backgroundColor: colors.background,
                      color: colors.text,
                      borderColor: colors.border,
                    }}
                  >
                    Précédent
                  </button>
                )}
                {currentStep < totalSteps ? (
                  <button
                    type="button"
                    onClick={nextStep}
                    className="px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-opacity-50 transition duration-150 ease-in-out"
                    style={{
                      backgroundColor: colors.primary,
                      color: colors.background,
                    }}
                  >
                    Suivant
                  </button>
                ) : (
                  <div className="flex items-end justify-end flex-col gap-2">
                    <button
                      type="submit"
                      disabled={isSubmitting || Object.keys(errors).length > 0}
                      className=" px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-opacity-50 transition duration-150 ease-in-out disabled:opacity-50"
                      style={{
                        backgroundColor: colors.secondary,
                        color: colors.background,
                      }}
                    >
                      Soumettre
                    </button>
                    {Object.keys(errors).length > 0 && (
                      <p
                        className=" text-sm mt-2"
                        style={{
                          color: colors.secondary,
                        }}
                      >
                        Veuillez corriger les erreurs avant de soumettre.
                      </p>
                    )}
                  </div>
                )}
              </div>
            )}
          </Form>
        )}
      </Formik>
      <CookieBanner />
    </div>
  );
};

export default FormManager;

//TODO Fixé les bug de responsive !
